import { useEffect } from "react";
import { isMobileOnly } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ContentTop } from "common/src/component/ContentTop";
import {
  AboutContainer,
  AccountContainer,
  AccountDescription,
  PageContent,
  PageContentWrapper,
  StyledPageHeader,
  StyledPageHeaderWrapper,
} from "common/src/styledComponents/AccountPage";
import { StyledLink } from "common/src/styledComponents/CommonStyledComponents";
import { withRouter } from "react-router-dom";

const TermsAndConditions = ({
  pageWidth,
  pages,
  titles,
  server,
  player,
  skin,
}) => {
  const { t } = useTranslation();
  const isUK =
    player && player.country === "gb"
      ? true
      : server.geoIP.isoCode.toLowerCase() === "gb"
      ? true
      : false;
  useEffect(() => {
    // console.log(titles)
    document.title = titles["terms-and-conditions"];
  }, [titles]);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    scrollToTop();
  }, []);

  return (
    <>
      <ContentTop showProfileMenu={false} skin={skin} pages={pages} />
      <PageContent>
        <PageContentWrapper>
          <AccountContainer>
            <AboutContainer>
              <StyledPageHeaderWrapper>
                <StyledPageHeader
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "label_terms_and_conditions_title",
                      "Terms &amp; Conditions"
                    ),
                  }}
                ></StyledPageHeader>
              </StyledPageHeaderWrapper>
              {!isMobileOnly && (
                <StyledPageHeaderWrapper right>
                  <StyledLink
                    btnsolo="true"
                    btnnext="true"
                    to={`${
                      pages["sports-terms"]
                        ? pages["sports-terms"]
                        : pages["privacy-policy"]
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: t(
                        pages["sports-terms"]
                          ? "label_next_sports_terms"
                          : "label_next_pricay_and_safety"
                      ),
                    }}
                  ></StyledLink>
                </StyledPageHeaderWrapper>
              )}
            </AboutContainer>
            <AccountDescription
              dangerouslySetInnerHTML={{
                __html: isUK
                    ? t("text_terms_and_conditions_uk")
                    : t("text_terms_and_conditions"),
              }}
            ></AccountDescription>
          </AccountContainer>
        </PageContentWrapper>
      </PageContent>
    </>
  );
};

export default withRouter(TermsAndConditions);
